import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import Skeleton from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../../Features/Cart/cartSlice";
import { getProductsList } from "../../../api/services";

import "swiper/css";
import "swiper/css/navigation";
import "react-loading-skeleton/dist/skeleton.css";
import { GoChevronLeft, GoChevronRight } from "react-icons/go";
import toast from "react-hot-toast";
import ProductCard from "../../Home/Limited/ProductCard";

// ✅ Destructure catId from props
const RelatedProducts = ({ catId }) => {
  const dispatch = useDispatch();
  const [categoryProducts, setCategoryProducts] = useState([]);
  const [categoryProductsLoading, setCategoryProductsLoading] = useState(true);

  /* ================= FETCH CATEGORIES ================= */
  useEffect(() => {
    if (!catId) return;
    fetchProducts(catId);
  }, [catId]);

  const fetchProducts = async (categoryId) => {
    try {
      setCategoryProductsLoading(true);
      const dataFilter = {
        category: categoryId,
        _page: 1,
        _perPage: 10,
      };
      const res = await getProductsList(dataFilter);
      setCategoryProducts(res?.data?.data?.products || []);
    } catch (error) {
      console.error(error);
    } finally {
      setCategoryProductsLoading(false);
    }
  };

  const cartItems = useSelector((state) => state.cart.items);

  // ✅ Accept product object, not just id
  const handleAddToCart = (product) => {
    const productInCart = cartItems.find(
      (item) => item.productID === product.productID,
    );

    if (productInCart && productInCart.quantity >= 20) {
      toast.error("Product limit reached", {
        duration: 2000,
        style: {
          backgroundColor: "#ff4b4b",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#ff4b4b",
        },
      });
    } else {
      dispatch(addToCart(product));
      toast.success(`Added to cart!`, {
        duration: 2000,
        style: {
          backgroundColor: "#07bc0c",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#07bc0c",
        },
      });
    }
  };

  // Guard in case catId is missing
  if (!catId) return null;

  return (
    <div className="new_arrival_product_wrap">
      <div className="container">
        <div style={{ marginBottom: 40 }}>
          <div className="deal_of_day_head d-flex justify-content-between heading_line">
            <h3 className="content-title theme_color">Recommendation</h3>
          </div>

          <div style={{ position: "relative" }}>
            {categoryProductsLoading ? (
              <Swiper
                slidesPerView={4}
                spaceBetween={15}
                loop={false}
                navigation={false}
                modules={[Navigation]}
                breakpoints={{
                  320: { slidesPerView: 1 },
                  576: { slidesPerView: 2 },
                  768: { slidesPerView: 3 },
                  1024: { slidesPerView: 4 },
                }}
              >
                {Array(4)
                  .fill(0)
                  .map((_, idx) => (
                    <SwiperSlide key={idx}>
                      <div className="poroduct_item_block">
                        <div
                          className="product_img_block"
                          style={{
                            height: "180px",
                            position: "relative",
                            borderRadius: "8px",
                            overflow: "hidden",
                          }}
                        >
                          <Skeleton
                            height="100%"
                            width="100%"
                            style={{ position: "absolute", top: 0, left: 0 }}
                          />
                        </div>
                        <div
                          className="product_details_block"
                          style={{
                            textAlign: "center",
                            marginTop: "10px",
                            marginBottom: "10px",
                          }}
                        >
                          <Skeleton height={15} width="90%" />
 
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              gap: "10px",
                              marginTop: "10px",
                            }}
                          >
                            <Skeleton height={30} width={100} />
                            <Skeleton height={30} width={100} />
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
              </Swiper>
            ) : (
              <>
                <Swiper
                  slidesPerView={4}
                  spaceBetween={15}
                  loop={(categoryProducts || []).length > 4}
                  navigation={{
                    prevEl: `.deal-prev-${catId}`,
                    nextEl: `.deal-next-${catId}`,
                  }}
                  modules={[Navigation]}
                  breakpoints={{
                    320: { slidesPerView: 1 },
                    576: { slidesPerView: 2 },
                    768: { slidesPerView: 3 },
                    1024: { slidesPerView: 4 },
                  }}
                >
                  {categoryProducts.map((item) => {
                    return (
                      <SwiperSlide key={item.id}>
                        <ProductCard
                          product={item}
                          onAddToCart={handleAddToCart}
                        />
                      </SwiperSlide>
                    );
                  })}
                </Swiper>

                {/* Navigation buttons */}
                {categoryProducts.length > 5 && (
                  <>
                    <div
                      className={`deal-prev-${catId}`}
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "-5px",
                        transform: "translateY(-50%)",
                        zIndex: 10,
                        background: "#fff",
                        padding: "8px",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <GoChevronLeft size={20} />
                    </div>
                    <div
                      className={`deal-next-${catId}`}
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "-5px",
                        transform: "translateY(-50%)",
                        zIndex: 10,
                        background: "#fff",
                        padding: "8px",
                        borderRadius: "50%",
                        cursor: "pointer",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <GoChevronRight size={20} />
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RelatedProducts;
